export enum ReportType {
    'ApplicationReport' = 1,
    'UtilizationInsightsReport'
}
